<template>
  <v-container class="page">
<table>

<tbody>

<br><br>

  <div>

  <table style="border: 1px solid; text-align: left; font-size: 12px;">
  <tbody>

  <tr>
  <td style="width: 250px;"></td>
  <td></td>
  </tr>

  <tr>
  <th colspan="2" style="border: 1px solid; background-color: #ffffcc; text-align: center; font-size: 24px;">
    ARKUSZ MIESIĘCZNY MATERIAŁÓW EDUKACYJNYCH
  </th>
  </tr>

  <tr>
  <td style="border: 1px solid; width: 100px;">
  <p class="cell-in-first-table"><span><strong>Nazwisko i Imię:</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #ffffcc;">
  <p class="cell-in-first-table"><span><strong>{{ imie }} {{ nazwisko }}</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span><strong>Okres:</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #ffffcc;">
  <p class="cell-in-first-table"><span><strong>{{ miesiac }}</strong></span></p>
  </td>
  </tr>

  <tr>
    <td colspan="2" style="border: 1px solid; background-color: #fff; text-align: center; font-size: 24px; height: 20px;"></td>
  </tr>

</tbody>
</table>

  <tr style="text-align: center;">
    <td style="border: 1px solid; background-color: #ffffcc; width: 100px;">
        <p class="cell-in-first-table">L.p. dzień miesiąca</p>
    </td>
    <td style="border: 1px solid; background-color: #ffffcc;">
        <p class="cell-in-first-table">Dzień tygodnia</p>
    </td>
    <td style="border: 1px solid; background-color: #ffffcc; width: 350px;">
        <p class="cell-in-first-table">Opis zadań twórczych / Nazwa Materialu Edukacyjnego (ME)/ Ewentualny urlop wypoczynkowy (UW)</p>
    </td>
    <td style="border: 1px solid; background-color: #ffffcc;">
        <p class="cell-in-first-table">Ilość przepracowanych <strong>godzin twórczych</strong></p>
    </td>
    <td style="border: 1px solid; background-color: #ffffcc;">
        <p class="cell-in-first-table">Ilość przepracowanych <strong>godzin na czynności pozostałe</strong></p>
    </td>
    <td style="border: 1px solid; background-color: #ffffcc;">
        <p class="cell-in-first-table">Łączna ilość przepracowanych godzin</p>
    </td>
  </tr>

  <tr 
    v-for="(date, index) in datyTab()"
    v-bind:key="index"
    style="text-align: center;"
  >
    <td style="border: 1px solid;">
        <p style="margin-top: 2px;">{{ date }}</p>
    </td>
    <td style="border: 1px solid;">
        <p class="cell-in-first-table">{{ dniTygodniaTab()[index] }}</p>
    </td>
    <td style="border: 1px solid;">
        <p class="cell-in-first-table">{{ opisyZadanTworczychTab()[index] }}</p>
    </td>
    <td style="border: 1px solid;">
        <p class="cell-in-first-table">{{ iloscGodzinTworczychTab()[index] }}</p>
    </td>
    <td style="border: 1px solid;">
        <p class="cell-in-first-table">{{ iloscPozostalychGodzinTab()[index] }}</p>
    </td>
    <td style="border: 1px solid;">
        <p class="cell-in-first-table">{{ iloscGodzinTab()[index] }}</p>
    </td>
  </tr>

  <tr>
      <td colspan="3" style="border: 1px solid;">
          <p class="cell-in-first-table"><strong>Łącznie godzin</strong></p>
      </td>
      <td style="text-align: center; border: 1px solid;" >
          <p class="cell-in-first-table"><strong>{{ sumaTworczeFloor() }}</strong></p>
      </td>
      <td style="text-align: center; border: 1px solid;">
          <p class="cell-in-first-table"><strong>{{ sumaPozostaleFloor() }}</strong></p>
      </td>
      <td style="text-align: center; border: 1px solid;">
          <p class="cell-in-first-table"><strong>{{ sumaGodzin }}</strong></p>
      </td>
  </tr>

    <tr>
        <td style="height: 20px;"></td>
    </tr>

  <tr>
      <td colspan="3">
          <p style="border: 1px solid; padding-left: 10px;"><strong>Wykaz utworów pracowniczych stworzonych w miesiącu (mm-rr):</strong></p>
      </td>
      <td colspan="3">
          <p style="border: 1px solid; padding-left: 10px; background-color: #ffffcc;"><strong>{{ miesiac }}</strong></p>
      </td>
  </tr>

  <tr
    v-for="(utwor, index) in wykazyUtworowTab()"
    v-bind:key="index+31"
  >
      <td style="border: 1px solid; background-color: #ffffcc;">
          <p class="cell-in-first-table" style="text-align: center;"><strong>{{ index + 1 }}.</strong></p>
      </td>
      <td colspan="5" style="border: 1px solid;">
          <p class="cell-in-first-table">{{ utwor }}</p>
      </td>
  </tr>

    <tr>
        <td style="height: 20px;"></td>
    </tr>

  <tr style="background-color: #ffffcc;">
      <td colspan="5" style="border: 1px solid;">
          <p class="cell-in-first-table"><strong>Procentowy udział godzin twórczych w danym miesiącu</strong></p>
      </td>
      <td style="text-align: center; border: 1px solid;">
          <p class="cell-in-first-table"><strong>{{ procentowyUdzialGodzin() }}%</strong></p>
      </td>
  </tr>

    <tr>
        <td style="height: 30px;"></td>
    </tr>

    <tr>
        <td></td>
        <td></td>
        <td colspan="2" style="background-color: #a4c2f4;">
            <p class="cell-in-first-table">Imię i nazwisko koordynatora zatwierdzającego Arkusz:</p>
        </td>
        <td>
            <p class="cell-in-first-table">{{ koordynator }}</p>
        </td>
    </tr>

    <tr>
        <td style="height: 20px;"></td>
    </tr>

    <tr>
        <td></td>
        <td></td>
        <td colspan="2" style="background-color: #a4c2f4;">
            <p class="cell-in-first-table">Osoba Zatwierdzajaca Dział Edukacja z datą zatwierdzenia Arkusza</p>
        </td>
        <td>
            <p class="cell-in-first-table">{{ osobaZatwierdzajaca }}</p>
        </td>
    </tr>

    <tr>
        <td style="height: 20px;"></td>
    </tr>

    <tr>
        <td></td>
        <td></td>
        <td colspan="2" style="background-color: #a4c2f4;">
            <p class="cell-in-first-table">Imię i nazwisko pracownika działu kadr i płac zatwierdzającego do rozliczenia</p>
        </td>
        <td>
            <p class="cell-in-first-table">{{ kadryPlace }}</p>
        </td>
    </tr>

  </div>

  </tbody></table>

  </v-container>
</template>

<script>
export default {
  name: 'ArkuszSkrot',
  props: {
  },
  data () {
    return {
      imie: '',
      nazwisko: '',
      miesiac: '',
      sumaTworcze: '',
      sumaPozostale: '',
      sumaGodzin: '',
      procentowyUdzial: 0,
      koordynator: '',
      osobaZatwierdzajaca: '',
      kadryPlace: '',
      opisyZadanTworczych: '',
      iloscGodzinTworczych: '',
      iloscPozostalychGodzin: '',
      iloscGodzin: '',
      wykazyUtworow: '',
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    datyTab() {
      const result = ['2025-07-01', '2025-07-02', '2025-07-03', '2025-07-04', '2025-07-05', '2025-07-06', '2025-07-07', '2025-07-08', '2025-07-09', '2025-07-10', '2025-07-11', '2025-07-12', '2025-07-13', '2025-07-14', '2025-07-15', '2025-07-16', '2025-07-17', '2025-07-18', '2025-07-19', '2025-07-20', '2025-07-21', '2025-07-22', '2025-07-23', '2025-07-24', '2025-07-25', '2025-07-26', '2025-07-27', '2025-07-28', '2025-07-29', '2025-07-30', '2025-07-31'];
      return result
    },
    dniTygodniaTab() {
      const result = ['WT', 'ŚR', 'CZ', 'PT', 'SB', 'ND', 'PN', 'WT', 'ŚR', 'CZ', 'PT', 'SB', 'ND', 'PN', 'WT', 'ŚR', 'CZ', 'PT', 'SB', 'ND', 'PN', 'WT', 'ŚR', 'CZ', 'PT', 'SB', 'ND', 'PN', 'WT', 'ŚR', 'CZ'];
      return result
    },
    opisyZadanTworczychTab() {
      let tablica = this.opisyZadanTworczych.split('|');
      switch(this.nazwisko) {
        case 'Gryziecka':
  tablica = [];
  tablica.push(`odr ANG kl 2: oprac. graf książki:
FM-2008 AP2U10L7
Podr ANG kl 1: oprac. graf książki:
FM-2013 AP3U10L9
Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia:
FM-1611 Angielski podręcznik część 3_Unit 3, 
Angielski podręcznik część 3_Unit 4`,
   `Podr ANG kl 1: oprac. graf książki:
FM-2013 AP3U10L9
Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia:
FM-1611 Angielski podręcznik część 3_Unit 3,
Angielski podręcznik część 3_Unit 6
Projektowanie dodatkowych elementów graficznych z aktywnościami do podręczników z ANG`,
    `Podr ANG kl 3: oprac. graf książki:
FM-2014 AP3U10L10
Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia:
FM-1611 Angielski podręcznik część 3_Unit 5,
Angielski podręcznik część 3_Unit 7,
Angielski podręcznik część 3_Unit 8,
Angielski podręcznik część 3_Unit 9`,
     ``,``,
     ``,`Podr ANG kl 3: oprac. graf książki:
FM-2014 AP3U10L10
Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia:
FM-1611 Angielski podręcznik część 3_Unit 1,
Angielski podręcznik część 3_Unit 2,
Angielski podręcznik część 3_Unit 10,`,
     `Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia:
FM-1611 Angielski podręcznik część 3_Unit 2,
Angielski podręcznik część 3_Unit 3,
Angielski podręcznik część 3_Unit 4,
Angielski podręcznik część 3_Unit 5
Projektowanie dodatkowych elementów graficznych z aktywnościami do podręczników z ANG`,
     `Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia:
FM-1611 Angielski podręcznik część 3_Unit 5,
Angielski podręcznik część 3_Unit 6,
Angielski podręcznik część 3_Unit 7,
Angielski podręcznik część 3_Unit 8
Projektowanie dodatkowych elementów graficznych z aktywnościami do podręczników z ANG`,
     `Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia:
FM-1611 Angielski podręcznik część 3_Unit 8,
FM-1611 Angielski podręcznik część 3_Unit 9,
FM-1611 Angielski podręcznik część 3_Unit 10`,
     `Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia:
FM-1611 Angielski podręcznik część 3_Unit 10
FM-2027 Opracowanie graficzne okładek do podręczników z ANG z bohaterami 
FM-2027 Opracowanie graficzne okładek do podręczników z ANG z fotografią`,
     ``,``,`FM-2027 Opracowanie graficzne okładek do podręczników z ANG z bohaterami 
FM-2027 Opracowanie graficzne okładek do podręczników z ANG z fotografią
FM-2028 Opracowanie Teacher's Guide do podręcznika część 1`,`FM-2028 Opracowanie Teacher's Guide do podręcznika część 1
Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia:
FM-1611 Angielski podręcznik część 3_Unit 4`,
     `FM-2028 Opracowanie Teacher's Guide do podręcznika część 1`,
     `FM-2028 Opracowanie Teacher's Guide do podręcznika część 1`,
     `FM-2028 Opracowanie Teacher's Guide do podręcznika część 1`,
     ``,
     ``,`FM-2028 Opracowanie Teacher's Guide do podręcznika część 1`,`FM-2028 Opracowanie Teacher's Guide do podręcznika część 1`,
     `FM-2028 Opracowanie Teacher's Guide do podręcznika część 1`,
     `FM-2028 Opracowanie Teacher's Guide do podręcznika część 1`,
     `FM-1609 Weryfikacja i poprawki rozdziałów w podręczniku część 1
FM-2028 Opracowanie Teacher's Guide do podręcznika część 1
FM-2040 AP3-Culture-1`,``,``,`FM-2028 Opracowanie Teacher's Guide do podręcznika część 1
Podręcznik do angielskiego klasa 3: opracowanie graficzne książki:
FM-2040 AP3-Culture-1
FM-2041 AP3-Culture-2`, `Podręcznik do angielskiego klasa 3: opracowanie graficzne książki:
FM-2042 AP3-Culture-3
FM-2043 AP3-Culture-4`, `Podręcznik do angielskiego klasa 3: opracowanie graficzne książki:
FM-2043 AP3-Culture-4
FM-2044 AP3-Culture-5
FM-2028 Opracowanie Teacher's Guide do podręcznika część 1`, `FM-2028 Opracowanie Teacher's Guide do podręcznika część 1`);
  break;
        case 'Rzepka':
  tablica = [];
  tablica.push(`"Ebooki z kursu Architekt i Grafik 3D
Tworzenie ebooka ""Moodboard wnętrzarski"". Dokończenie pozostałych 6 stron i zakończenie.
Tworzenie ebooka numer 2 Poduszkowy design – zaprojektuj wzór."`,
   `"Ebooki z kursu Architekt i Grafik 3D Tworzenie ebooka numer 3 Strefa chilloutu."`,
    `"Ebooki z kursu Architekt i Grafik 3D Poprawki i korekta graficzno tekstowa we wszystkich trzech ebookach. Numer 1, 2 i 3."`,
     `"Podr ang: praca nad oprawą graficzną dla podręcznika numer 1.

FM-1957        AP1U9L1 Ang Podr część 1 Unit 9 Lekcja 1
FM-1967        AP1U9L2 Ang Podr część 1 Unit 9 Lekcja 2
"`,
          ``,``,
      `"Podr ang: praca nad oprawą graficzną dla podręcznika numer 1.

FM-1971        AP1U9L3 Ang Podr część 1 Unit 9 Lekcja 3

FM-1977        AP1U9L4 Ang Podr część 1 Unit 9 Lekcja 4
"`,`"Podr ang: praca nad oprawą graficzną dla podręcznika numer 1.

FM-1983        AP1U9L5 Ang Podr część 1 Unit 9 Lekcja 5
FM-1988        AP1U9L6 Ang Podr część 1 Unit 9 Lekcja 6"`,
     `"Podr ang: praca nad oprawą graficzną dla podręcznika numer 1.

FM-1983        AP1U9L5 Ang Podr część 1 Unit 9 Lekcja 5
FM-1988        AP1U9L6 Ang Podr część 1 Unit 9 Lekcja 6"`,
     `Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia: FM-1609 Angielski podręcznik część 1_Unit 1`,
     `Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia: FM-1609 Angielski podręcznik część 1_Unit 2`,
     ``,``,
     `"Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia: FM-1609 Angielski podręcznik część 1_Unit 3
FM-2027 Projektowanie 3 propozycji okładek dla podręczników"`,
     `Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia: FM-1609 Angielski podręcznik część 1_Unit 4`,
     `Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia: FM-1609 Angielski podręcznik część 1_Unit 5`,
     `Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia: FM-1609 Angielski podręcznik część 1_Unit 6`,
     `Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia: FM-1609 Angielski podręcznik część 1_Unit 7`,           ``,``,
     `Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia: FM-1609 Angielski podręcznik część 1_Unit 8`,
`Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia: FM-1609 Angielski podręcznik część 1_Unit 9`,
     `Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia: FM-1609 Angielski podręcznik część 1_Unit 10`,
     `"Projektowanie ""Kart Postaci"" do poszczególnych części podręczników.
Karta postaci do podręcznika numer 1
Karta postaci do podręcznika numer 2
Karta postaci do podręcznika numer 3"`,
     `"Podr ang: praca nad oprawą graficzną dla podręcznika numer 1.
       
FM-2029  Ang Podr część 1 - Culture - 1
FM-2030  Ang Podr część 1 - Culture - 2"`, ``, ``,
     `"FM-2031  Ang Podr część 1 - Culture - 3
FM-2032 Ang Podr część 1 - Culture - 4"`,`DW`, `"FM-2033  Ang Podr część 1 - Culture - 5
FM-2034 Ang Podr część 1 - Culture - 6"`, `Wybór jedenj propozycji kart postaci z trzech przygotownych i dostosowanie dwóch pozostałych kart z podręcznika 1 i 2 pod jedną ujednoliconą propozycję`, ``);
  break;
        case 'Susak':
          tablica = [];
          tablica.push(``);
        break;
        case 'Musiałowska':
          tablica = [];
          tablica.push(``);
        break;
        case 'Gawron':
          tablica = [];
          tablica.push(``);
        break;
        case 'Sowula':
          tablica = [];
          tablica.push(``, `DW`, ``, ``, ``, `Kurs programowanie: tworzenie materiałów dla nieobecznych uczniów do lekcji 33 kursu poziomu 2 "33_PM3_MDN_StatkiCz3"`, `Kurs programowanie: stworzenie materiałów dla nieobecznych uczniów do lekcji 33 kursu poziomu 2 "33_PM3_MDN_StatkiCz3", quizu do lekcji 31 kursu poziomu 0 "31_PM1_Quiz_ŚredniowiecznaWioskaRTSCz2", quizu do lekcji 32 kursu poziomu 0 "32_PM1_Quiz_StrażacyNaRatunekCz1", quizu do lekcji 33 kursu poziomu 0 "33_PM1_Quiz_StrażacyNaRatunekCz2"`, `Kurs programowanie: stworzenie quizu do lekcji 34 kursu poziomu 0 "34_PM1_Quiz_WakacjeNaWypasie", quizu do lekcji 31 kursu poziomu 1 "31_PM2_Quiz_SaperCz1", quizu do lekcji 32 kursu poziomu 1 "32_PM2_Quiz_SaperCz2", quizu do lekcji 33 kursu poziomu 1 "33_PM2_Quiz_SaperCz3", quizu do lekcji 34 kursu poziomu 1 "34_PM2_Quiz_PoszukiwaczePrzygód", quizu do lekcji 31 kursu poziomu 2 "31_PM3_Quiz_StatkiCz1", quizu do lekcji 32 kursu poziomu 2 "32_PM3_Quiz_StatkiCz2", quizu do lekcji 33 kursu poziomu 2 "33_PM3_Quiz_StatkiCz3, tworzenie paczki skinów "Fasolki" - nagrody za 30 wykonanych wyzwań tygodnia przez uczniów kursu poziomu 0`, `Kurs programowanie: stworzenie paczki skinów "Fasolki" - nagrody za 30 wykonanych wyzwań tygodnia przez uczniów kursu poziomu 0, stworzenie paczki skinów "Moby" - nagrody za 30 wykonanych wyzwań tygodnia przez uczniów kursu poziomu 1, tworzenie paczki skinów "Wakacyjnie " - nagrody za 30 wykonanych wyzwań tygodnia przez uczniów kursu poziomu 2`, `Kurs programowanie: stworzenie paczki skinów "Wakacyjnie" - nagrody za 30 wykonanych wyzwań tygodnia przez uczniów kursu poziomu 2, tworzenie mapy do lekcji 34 dla kursu poziomu 2 "Programistyczny szlak"`, ``, ``, `Kurs programowanie: tworzenie mapy do lekcji 34 dla kursu poziomu 2 "Programistyczny szlak"`, `Kurs programowanie: tworzenie mapy do lekcji 34 dla kursu poziomu 2 "Programistyczny szlak"`, `Kurs programowanie: tworzenie mapy do lekcji 34 dla kursu poziomu 2 "Programistyczny szlak"`, `Kurs programowanie: tworzenie mapy do lekcji 34 dla kursu poziomu 2 "Programistyczny szlak"`, `Kurs programowanie: tworzenie mapy do lekcji 34 dla kursu poziomu 2 "Programistyczny szlak"`, ``, ``, `Kurs programowanie: stworzenie mapy do lekcji 34 dla kursu poziomu 2 "Programistyczny szlak", tworzenie scenariusza dla nauczycieli do lekcji 34 kursu poziomu 2 "34_PM3_KON_ProgramistycznySzlak"`, `Kurs programowanie: stworzenie scenariusza dla nauczycieli do lekcji 34 kursu poziomu 2 "34_PM3_KON_ProgramistycznySzlak", stworzenie planszy podsumowującej do lekcji 34 kursu poziomu 2 "34_PM3_MPL_ProgramistycznySzlak"`, `Kurs programowanie: tworzenie materiałów dla nieobecnych uczniów do lekcji 34 kursu poziomu 2 "34_PM3_MDN_ProgramistycznySzlak"`, `Kurs programowanie: stworzenie materiałów dla nieobecnych uczniów do lekcji 34 kursu poziomu 2 "34_PM3_MDN_ProgramistycznySzlak", quizu do lekcji 34 kursu poziomu 2 "34_PM3_Quiz_ProgramistycznySzlak", Kurs tworzenie gier: stworzenie quizu do lekcji 1 kursu "1_TG_Quiz_PierwszeKroki", stworzenie quizu do lekcji 2 kursu "2_TG_Quiz_BohaterToZaMało", stworzenie quizu do lekcji 3 kursu "3_TG_Quiz_MojaPierwszaGra", stworzenie quizu do lekcji 4 kursu "4_TG_Quiz_NoweWyzwanie", stworzenie quizu do lekcji 5 kursu "5_TG_Quiz_EfektyZCząsteczkami" `, `Kurs tworzenie gier: stworzenie quizu do lekcji 6 kursu "6_TG_Quiz_PunktyIŻycia", stworzenie quizu do lekcji 7 kursu "7_TG_Quiz_MelodyczneZakończenie", stworzenie quizu do lekcji 8 kursu "8_TG_Quiz_WężoweCzary", stworzenie quizu do lekcji 9 kursu "9_TG_Quiz_WężoweRuchy", stworzenie quizu do lekcji 10 kursu "10_TG_Quiz_SterowanieToPodstawa", stworzenie quizu do lekcji 11 kursu "11_TG_Quiz_PełnyWąż", stworzenie quizu do lekcji 12 kursu "12_TG_Quiz_SprawdźSię"`, ``, ``, ``, ``, ``, ``, `DW`);
        break;
      }
      return tablica
    },
    iloscGodzinTworczychTab() {
      let tablica = this.iloscGodzinTworczych.split('|');
      return tablica
    },
    iloscPozostalychGodzinTab() {
      let tablica = this.iloscPozostalychGodzin.split('|');
      return tablica
    },
    iloscGodzinTab() {
      let tablica = this.iloscGodzin.split('|');
      return tablica
    },
    wykazyUtworowTab() {
      let tablica = this.wykazyUtworow.split('|');
      switch(this.nazwisko) {
        case 'Rzepka':
          tablica = [];
          tablica.push(`"Ebooki z kursu Architekt i Grafik 3D
Wykonanie ebooka numer 1 "Moodboard wnętrzarski"."`,`"Ebooki z kursu Architekt i Grafik 3D
Wykonanie ebooka numer 2 "Poduszkowy design – zaprojektuj wzór."`,`"Ebooki z kursu Architekt i Grafik 3D
Wykonanie ebooka numer 3 "Strefa chilloutu."`, `"Podręczniki do angielskiego, książka numer 1:

FM-1957        Ang Podr część 1 Unit 9 Lekcja 1 
FM-1967        Ang Podr część 1 Unit 9 Lekcja 2 
FM-1971        Ang Podr część 1 Unit 9 Lekcja 3 
FM-1977        Ang Podr część 1 Unit 9 Lekcja 4 
FM-1983        Ang Podr część 1 Unit 9 Lekcja 5
FM-1988        Ang Podr część 1 Unit 9 Lekcja 6
FM-1993        Ang Podr część 1 Unit 9 Lekcja 7
FM-1999        Ang Podr część 1 Unit 9 Lekcja 8
FM-2003        Ang Podr część 1 Unit 9 Lekcja 9
FM-2004        Ang Podr część 1 Unit 9 Lekcja 10"`, `"Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia: 
FM-1609 Angielski podręcznik część 1_Unit 1
FM-1609 Angielski podręcznik część 1_Unit 2
FM-1609 Angielski podręcznik część 1_Unit 3
FM-1609 Angielski podręcznik część 1_Unit 4
FM-1609 Angielski podręcznik część 1_Unit 5
FM-1609 Angielski podręcznik część 1_Unit 6
FM-1609 Angielski podręcznik część 1_Unit 7
FM-1609 Angielski podręcznik część 1_Unit 8
FM-1609 Angielski podręcznik część 1_Unit 9
FM-1609 Angielski podręcznik część 1_Unit 10"`, `"Opracowanie "Kart Postaci" do poszczególnych części podręczników.
Karta postaci do podręcznika numer 1
Karta postaci do podręcznika numer 2
Karta postaci do podręcznika numer 3"`, `FM-2027 Stworzenie trzech propozycji okładek dla podręczników. Dla podręcznika numer 1, 2 i 3`, `Dostosowanie kart postaci pod jedną wybraną wersję z trzech przygotownych.`, `"Podr ang: praca nad oprawą graficzną dla podręcznika numer 1.
       
FM-2029  Ang Podr część 1 - Culture - 1
FM-2030  Ang Podr część 1 - Culture - 2
FM-2031  Ang Podr część 1 - Culture - 3
FM-2032 Ang Podr część 1 - Culture - 4
FM-2033  Ang Podr część 1 - Culture - 5
FM-2034 Ang Podr część 1 - Culture - 6"`);
          break;
          case 'Gryziecka':
          tablica = [];
          tablica.push(`"FM-2013 Angielski Podr część 1 Unit 10 Lekcja 9
FM-2014 Angielski Podr część 1 Unit 10 Lekcja 10"`,
          `"FM-1611 Opracowanie graficzne unitu oraz dostosowanie projektu pod nowe założenia:
Angielski podręcznik część 3_Unit 1,
Angielski podręcznik część 3_Unit 2,
Angielski podręcznik część 3_Unit 3,
Angielski podręcznik część 3_Unit 4,
Angielski podręcznik część 3_Unit 5,
Angielski podręcznik część 3_Unit 6,
Angielski podręcznik część 3_Unit 7,
Angielski podręcznik część 3_Unit 8,
Angielski podręcznik część 3_Unit 9,
Angielski podręcznik część 3_Unit 10"`, `"Projektowanie dodatkowych elementów graficznych z aktywnościami do podręczników z ANG"`, `"FM-2027 Opracowanie graficzne okładek do podręczników z ANG z bohaterami
FM-2027 Opracowanie graficzne okładek do podręczników z ANG z fotografią"`, `"FM-2028 Teacher's Guide do podręcznika część 1"`, `"FM-2040 Angielski Podręcznik część 3 Culture 1
FM-2041 Angielski Podręcznik część 3 Culture 2
FM-2042 Angielski Podręcznik część 3 Culture 3
FM-2043 Angielski Podręcznik część 3 Culture 4
FM-2044 Angielski Podręcznik część 3 Culture 5"`);
          break;
          case 'Susak':
            tablica = [];
            tablica.push(`>fm-1191 / [GP3]/PREZ/Książka nr 9 - od strony 13 ksiązki`,`>fm-353 / [PG]/MDN/EE3/26-30 - lekcja 28 prezentację`,`">fm-1102 / [M6]/PREZ-MPL/26-30  - Lekcja 30 prezentacja + materiały po lekcjach
"`,`>fm-1221 / [LT2]/prez/31-34 - lekcja 31 prezentacja`,`>fm-356 / [PG]/MDN/EE3/31-34 - 31,32 prezentacja`,`>fm-1035 / [PG]/MDN/EE1/31-34 - lekcja 31,32 prezentacja`,`>fm-331 / [PG]/MDN/EE1/16-20 - 16,17 prezentacja`,`>fm-1020 / [PG]/MDN/EE2/26-30  - lekcja 29,30 prezentacja`,`>fm-1206 / [M6]/PREZ-MPL/31-34 - lekcja 31 prezentacja + materiały po lekcji`,`>fm-1205 / [M5]/PREZ-MPL/31-34 - lekcja 31 prezentacja i materiały po lekcjach`,`>fm-341 / [PG]/MDN/EE1/26-30 - materiały dla nauczyciela lekcja 29,30`,`>fm-331 / [PG]/MDN/EE1/16-20 - lekcja 18,19,20 prezentacja`,`">fm-352 / [PG]/MPL/EE2/31-34 - lekcja 31, 32, 33, 34 materiały po lekcjach
"`,`">fm-355 / [PG]/MPL/EE3/31-34  - lekcja 31, 32, 33, 34 materiały po lekcjach
"`,`>fm-1220 / [LT1]/PREZ/30-34 - lekcja 32 prezentacja`,`>fm-1221 / [LT2]/prez/31-34 - lekcja 32 oprezentacja`,`>fm-1206 / [M6]/PREZ-MPL/31-34 - lekcja 32 prezentacja + materiały po lekcjach`,`>fm-1205 / [M5]/PREZ-MPL/31-34 - lekcja 32 prezentacja + materiały po lekcjach`,`>fm-1251 / [GP3]/PREZ/Ebook 10 - książka do strony 18`,`">fm-1206 / [M6]/PREZ-MPL/31-34 - lekcja 33 prezentacja + materiały po lekcjach
"`,`>fm-1220 / [LT1]/PREZ/30-34 - lekcja 33 prezentacja`);
          break;
          case 'Płotczyk':
            tablica = [];
            tablica.push();
          break;
          case 'Cieplak':
            tablica = [];
            tablica.push(`"Rysunek: prezentacja, praca domowa i materiały po zajęciach:
FM-1471 Zajęcia 23 - Latające wyspy"`, `"Rysunek: prezentacja, praca domowa i materiały po zajęciach:
FM-1474 Zajęcia 24 - Co za świat"`, `"Rysunek: prezentacja, praca domowa i materiały po zajęciach:
FM-1492  Zajęcia 18 - Akwareli ciąg dalszy"`, `"Rysunek: prezentacja, praca domowa i materiały po zajęciach:
FM-1497 Zajęcia 25 - Z innej perspektywy"`, `"Rysunek: książka:
FM-1495 e-book 5"`, `"Wewnentrzne: prezentacja:
FM-1491 Pomoc Techniczna - instrukcja dla Koordynatora firmy LangLion B2B"`, `"Polski: prezentacja:
FM-1490 Szkolenie Nauczycielskie"`, `"Polski: prezentacja:
FM-1488 Slajdy 2 oraz 31 - 41 Zajęcia 23 dla klasy 7 - Czy lektura może nam pokrzyżować plany? - na podstawie noweli “Latarnik” Henryka Sienkiewicza."`, `"Polski: materiały po zajeciach:
FM-1489 slajdy 3-6  Zajęcia 23 dla klasy 7 - Czy lektura może nam pokrzyżować plany? - na podstawie noweli “Latarnik” Henryka Sienkiewicza."`, `"Polski: prezentacja:
FM-1493 Opracowanie wizualne slajdów 21 oraz 32-42 1 Zajęcia 24 dla klasy 7 - Oswajamy lirykę jako rodzaj literacki."`, `"Polski: materiały po zajeciach:
FM-1494 slajdy 6-10  Zajęcia 24 dla klasy 7 - Oswajamy lirykę jako rodzaj literacki."`, `"Matematyka: ksiazka:
FM-1496 Ebook nr 5 Matura"`, `"Matematyka: ksiazka:
FM-1498 Ebook nr 5 Egzamin dla klas 8"`);
          break;
          case 'Sowula':
          tablica = [];
          tablica.push(`Materiał dla nieobecnych uczniów "33_PM3_MDN_StatkiCz3" do lekcji 33 kursu poziomu 2`, `Quiz do lekcji 31 kursu poziomu 0 "31_PM1_Quiz_ŚredniowiecznaWioskaRTSCz2"`, `Quiz do lekcji 32 kursu poziomu 0 "32_PM1_Quiz_StrażacyNaRatunekCz1"`, `Quiz do lekcji 33 kursu poziomu 0 "33_PM1_Quiz_StrażacyNaRatunekCz2"`, `Quiz do lekcji 34 kursu poziomu 0 "34_PM1_Quiz_WakacjeNaWypasie"`, `Quiz do lekcji 31 kursu poziomu 1 "31_PM2_Quiz_SaperCz1"`, `Quiz do lekcji 32 kursu poziomu 1 "32_PM2_Quiz_SaperCz2"`, `Quiz do lekcji 33 kursu poziomu 1 "33_PM2_Quiz_SaperCz3"`, `Quiz do lekcji 34 kursu poziomu 1 "34_PM2_Quiz_PoszukiwaczePrzygód"`, `Quiz do lekcji 31 kursu poziomu 2 "31_PM3_Quiz_StatkiCz1"`, `Quiz do lekcji 32 kursu poziomu 2 "32_PM3_Quiz_StatkiCz2"`);
          break;
      }
      const result = tablica.filter(utwor => utwor !== '');
      return result
    },
    procentowyUdzialGodzin() {
      const decimalSumaTworcze = parseFloat(this.sumaTworcze.replace(/,/g, '.'));
      const decimalSumaGodzin = parseFloat(this.sumaGodzin.replace(/,/g, '.'));
      const procenty = Math.round((decimalSumaTworcze / decimalSumaGodzin) * 100);
      if(isNaN(procenty)) {
        return 0;
      } else {
        return procenty
      }
    },
    sumaTworczeFloor() {
      let decimalNumber = parseFloat(this.sumaTworcze.replace(/,/g, '.'))
      const result = parseFloat(decimalNumber).toFixed(2);
      return result
    },
    sumaPozostaleFloor() {
      let decimalNumber = parseFloat(this.sumaPozostale.replace(/,/g, '.'))
      const result = parseFloat(decimalNumber).toFixed(2);
      return result
    }
  },
  mounted () {
    if (this.imie) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}
table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
  width: 900px;
}
th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
ul.dashed {
  list-style-type: "- ";
  margin: 0;
}
.underline {
  text-decoration: underline;
}
.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}
#oswiadczenie {
  padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/ArkuszSkrot.vue